// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Hpei","inputWrap":"CustomTip_inputWrap__1tIha"};